import { render, staticRenderFns } from "./CategoryItems.vue?vue&type=template&id=619b13ce"
import script from "./CategoryItems.vue?vue&type=script&lang=js"
export * from "./CategoryItems.vue?vue&type=script&lang=js"
import style0 from "./CategoryItems.vue?vue&type=style&index=0&id=619b13ce&prod&lang=css"
import style1 from "./CategoryItems.vue?vue&type=style&index=1&id=619b13ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports